export default {
  title: '登出',
  type: 'get',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": null
      }
    }
  ]
}
